import React from 'react'
import ReactDOM from 'react-dom/client'
import r2wc from 'react-to-webcomponent'

import { CostBomDemo } from '~/widgets/CostBomDemo/CostBomDemo'

// Create the web component
const CostBomDemoWebComponent = r2wc(CostBomDemo, React, ReactDOM, {
  props: {
    title: 'string',
    width: 'string',
    height: 'string',
    className: 'string',
  },
})

// Register the custom element
if (!customElements.get('cost-bom-demo')) {
  customElements.define('cost-bom-demo', CostBomDemoWebComponent)
}

// Export for direct React usage if needed
export { CostBomDemo, CostBomDemoWebComponent }

// For UMD builds, also expose on window
if (typeof window !== 'undefined') {
  ;(
    window as unknown as { CostBomDemo: typeof CostBomDemoWebComponent }
  ).CostBomDemo = CostBomDemoWebComponent
}
